import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    HostBinding,
    Output,
} from "@angular/core";

import { SpsContentRowExpansionComponent } from "../content-row-expansion/sps-content-row-expansion.component";

@Component({
    selector: "sps-content-row",
    templateUrl: "./sps-content-row.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsContentRowComponent {
    static readonly displayName = "sps-content-row";
    static readonly props = {
        expanded: { event: true, type: "void" },
        collapsed: { event: true, type: "void" },
    };

    @HostBinding("class.sps-content-row") readonly _spsContentRowClass = true;
    @Output() expanded = new EventEmitter<void>();
    @Output() collapsed = new EventEmitter<void>();

    @ContentChild(SpsContentRowExpansionComponent, { static: false }) expansion: SpsContentRowExpansionComponent;

    get hasExpansion() {
        return !!this.expansion;
    }

    private _isExpanded = false;
    @HostBinding("class.sps-content-row--expanded")
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value: boolean) {
        if (this.hasExpansion && value !== this._isExpanded) {
            this._isExpanded = value;
            if (value) {
                this.expanded.emit();
            } else {
                this.collapsed.emit();
            }
            this.changeDetectorRef.markForCheck();
        }
    }

    constructor(private changeDetectorRef: ChangeDetectorRef) { }

    expand() {
        this.isExpanded = true;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    collapse() {
        this.isExpanded = false;
    }
}
